import { z } from 'zod';

export const certificateIssuanceStatus = z.enum(['active', 'revoked', 'expired', 'superseded']);

export type CertificateIssuanceStatus = z.infer<typeof certificateIssuanceStatus>;

export const certificateRevocationAction = z.enum(['revoke', 'unrevoke']);

export type CertificateRevocationAction = z.infer<typeof certificateRevocationAction>;
